import React, { ReactNode } from 'react'

import Badge from 'components_new/atoms/Badge'
import Icon, { IconName } from 'components_new/atoms/Icon'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import ListItemText from 'components_new/atoms/List/ListItemText'
import MenuItem, { MenuItemProps } from 'components_new/atoms/Menu/MenuItem'
import TooltipWrapper from 'components_new/atoms/TooltipWrapper'

import IconTip from 'components_new/molecules/IconTip'

interface OptionsMenuItemProps extends MenuItemProps {
  body?: string
  color?: 'error'
  disabled?: boolean
  iconBadge?: boolean
  iconName?: IconName
  iconRotation?: string
  infoTip?: ReactNode
  title: string | ReactNode
  tooltip?: string
}

const OptionsMenuItem = React.forwardRef(
  (props: OptionsMenuItemProps, ref: any) => {
    return (
      <TooltipWrapper title={props.tooltip}>
        <MenuItem
          disabled={props.disabled}
          onClick={props.onClick}
          onMouseDown={(event) => event.stopPropagation()}
          ref={ref}
        >
          {props.iconName ? (
            <ListItemIcon>
              <Badge color="primary" variant="dot" invisible={!props.iconBadge}>
                <Icon
                  color={props.color}
                  fontSize="small"
                  name={props.iconName}
                  sx={
                    props.iconRotation
                      ? { transform: `rotate(${props.iconRotation})` }
                      : undefined
                  }
                />
              </Badge>
            </ListItemIcon>
          ) : null}
          <ListItemText
            primary={props.title}
            primaryTypographyProps={{ color: props.color }}
            secondary={props.body}
            secondaryTypographyProps={{
              sx: { maxWidth: 256, whiteSpace: 'normal' }
            }}
          />
          {props.infoTip ? (
            <IconTip
              edge="end"
              placement="right"
              sx={{ ml: 1, pointerEvents: 'all!important' }}
              title={props.infoTip}
            />
          ) : null}
        </MenuItem>
      </TooltipWrapper>
    )
  }
)

OptionsMenuItem.displayName = 'OptionsMenuItem'
export default OptionsMenuItem
